import React from "react";
import { Set } from "immutable";

import Tree from "../Tree";

class SchemaClassTree extends React.Component {
  constructor(props) {
    super(props);

    this.url = props.url;

    this.loader = this.loader.bind(this);
    this.childrenSelector = this.childrenSelector.bind(this);
    this.rootsSelector = this.rootsSelector.bind(this);
    this.isOpen = this.isOpen.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.toggleSelected = this.toggleSelected.bind(this);

    if (props.onOpen) this.onOpen = props.onOpen;
    if (props.onClose) this.onClose = props.onClose;
    if (props.onSelect) this.onSelect = props.onSelect;
    if (props.onDeselect) this.onDeselect = props.onDeselect;
    if (props.loader) this.loader = props.loader;

    this.state = {
      selectedItems: Set(props.selected),
      openItems: Set(props.open)
    };
  }

  loader() {
    return fetch(this.url, {
      method: "POST",
      body: JSON.stringify({
        query: `query {
          schemaClasses {
            name
            dashname: name(format: DASHED)
            description
            children {
              name
            }
          }
        }`,
        variables: null
      }),
      headers: { "Content-Type": "application/json; charset=UTF-8" }
    })
      .then(response => response.json())
      .then(json =>
        json.schemaClasses.sort((a, b) => {
          const nameA = a.name.toUpperCase();
          const nameB = b.name.toUpperCase();

          if (nameA < nameB) return -1;

          if (nameA > nameB) return 1;

          return 0;
        })
      );
  }

  rootsSelector(items) {
    return items.filter(item => "Thing" === item.name);
  }

  childrenSelector(parent, items) {
    return items.filter(
      item => -1 < parent.children.map(child => child.name).indexOf(item.name)
    );
  }

  isSelected(item) {
    return this.state.selectedItems.includes(item.name);
  }

  isOpen(item) {
    return this.state.openItems.includes(item.name);
  }

  toggleSelected(item) {
    this.setState({
      selectedItems: this.isSelected(item)
        ? this.state.selectedItems.remove(item.name)
        : this.state.selectedItems.add(item.name)
    });

    // Keep in mind that the state hasn't change here yet.
    !this.isSelected(item) ? this.onSelect(item) : this.onDeselect(item);
  }

  toggleOpen(item) {
    this.setState({
      openItems: this.isOpen(item)
        ? this.state.openItems.remove(item.name)
        : this.state.openItems.add(item.name)
    });

    // Keep in mind that the state hasn't change here yet.
    !this.isOpen(item) ? this.onOpen(item) : this.onClose(item);
  }

  onOpen(item) {}

  onClose(item) {}

  onSelect(item) {}

  onDeselect(item) {}

  render() {
    return (
      <Tree
        loader={this.loader}
        rootsSelector={this.rootsSelector}
        childrenSelector={this.childrenSelector}
        isSelected={this.isSelected}
        isOpen={this.isOpen}
        toggleSelected={this.toggleSelected}
        toggleOpen={this.toggleOpen}
      />
    );
  }
}

export default SchemaClassTree;
